__webpack_require__.p = "https://live.pystatic.com/webassets/complaint-book/complaint-book-ms/1.4.6/";